import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { DateableRequest } from '../../models/filter.model';
import { baseQuery } from './base.query';

export interface SurveyResult {
  id: number;
  name: string;
  questions: Question[];
}

export interface Question {
  id: number;
  name: string;
  isExpired?: boolean;
}

export const questionApi = createApi({
  reducerPath: 'questionApi',
  baseQuery: baseQuery,
  tagTypes: ['Question'],
  endpoints: (builder) => ({
    getSurveyQuestions: builder.query<SurveyResult[], DateableRequest>({
      query: (args: DateableRequest) => ({
        url: `${API_PREFIX.NEXTGEN}${args?.request ?? API.SURVEY}?startDate=${args.startDate}&endDate=${args.endDate}`,
      }),
      transformResponse(baseQueryReturnValue) {
        const data = baseQueryReturnValue as SurveyResult[];
        const returnResult = data.map((item: SurveyResult) => {
          const immutableItem = { ...item };
          immutableItem.questions = item.questions.map((question: Question) => {
            return {
              ...question,
              parent: {
                ...item,
                questions: null,
              },
            };
          });
          return immutableItem;
        });
        return returnResult;
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSurveyQuestionsQuery } = questionApi;
